/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'react-bootstrap';
import { times } from 'lodash';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import moment from 'moment';

import Comment from './Comment';
import lookerApi from '../../../services/looker-api';

const filterRepliesOptions = ['Top Replies', 'Newest Replies'];

const CommentThread = ({ data, isOpen, query, handleClose, contentType }) => {
  const [loadingReplies, setLoadingReplies] = useState(false);
  const [replies, setReplies] = useState([]);

  const formatLoadingState = () => {
    if (!loadingReplies) {
      return null;
    }

    return (
      <div className="tvt-reactions__comment-thread-loading">
        {times(3, () => (
          <div className="tvt-reactions__comment-thread-loading-wrapper">
            <div className="tvt-reactions__comment-thread-loading-date" />
            <div className="tvt-reactions__comment-thread-loading-text" />
            <div className="tvt-reactions__comment-thread-loading-nums" />
          </div>
        ))}
      </div>
    );
  };

  const formatReplies = () => {
    if (loadingReplies) {
      return null;
    }

    return replies.length > 0 ? (
      <div className="tvt-reactions__comment-thread-wrapper">
        {replies.map(reply => (
          <div className="tvt-reactions__comment-thread-reply">
            <div className="tvt-reactions__comment-thread-reply-date">
              {moment(reply.date).format('MMMM DD, YYYY')}
            </div>
            <div className="tvt-reactions__comment-thread-reply-text">
              {reply.text}
            </div>
            <div className="tvt-reactions__comment-engagements-num">
              <FontAwesomeIcon
                className="tvt-reactions__comment-num-likes"
                icon={['far', 'heart']}
                size="1x"
              />
              <span>{reply.numLikes}</span>
            </div>
            <div>{}</div>
          </div>
        ))}
      </div>
    ) : (
      <div className="tvt-reactions__comment-thread-no-replies">No Replies</div>
    );
  };

  const fetchReplies = async sortType => {
    setReplies([]);
    setLoadingReplies(true);

    const result = await lookerApi.runInlineQueryStream(
      query.id,
      query.meta,
      {
        parentComment: {
          id: 'parentComment',
          isMulti: true,
          label: 'parentComment',
          value: [{ id: data.commentId, value: data.commentId }]
        }
      },
      'json',
      contentType === 'show'
        ? 'comment_feed.date asc'
        : 'pdt_movie_comment_feed.date asc'
    );

    if (result && result.data) {
      setReplies(result.data);
    } else {
      setReplies([]);
    }
    setLoadingReplies(false);
  };

  useEffect(() => {
    if (isOpen) {
      fetchReplies();
    }
  }, [isOpen]);

  return (
    <Modal
      className="tvt-reactions__comment-thread-modal"
      show={isOpen}
      onHide={handleClose}
      backdrop
    >
      {data && (
        <>
          <Comment
            data={data}
            filterRepliesOptions={filterRepliesOptions}
            onFilterReplies={fetchReplies}
          />
          <button
            onClick={handleClose}
            className="no-button-css tvt-reactions__comment-exit-thread"
          >
            <FontAwesomeIcon
              className="tvt-reactions__comment-exit-thread"
              icon={['fa', 'times']}
              size="1x"
            />
          </button>
          <div className="tvt-reactions__comment-thread-replies-wrapper">
            {formatLoadingState()}
            {formatReplies()}
          </div>
        </>
      )}
    </Modal>
  );
};

CommentThread.propTypes = {
  data: PropTypes.arrayOf(PropTypes.shape({})),
  isOpen: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  contentType: PropTypes.string
};

CommentThread.defaultProps = {
  data: null,
  contentType: 'show'
};

export default CommentThread;
